module.exports = __webpack_public_path__ + "img/miguel_angel_javier.8f4084ae.png";